export default {"src":"/_next/static/media/SG_v2.55db4e6c.svg","height":35,"width":53,"blurWidth":0,"blurHeight":0};